import React from "react";
import { AdminLayout, Loading, useSource } from "@opendash/core";
import { ParseSetView } from "@opendash/plugin-parse";
import { createComponent } from "@opendash/state";
import { TableViewType } from "@opendash/plugin-parse/dist/types";
import { notification } from "antd";
import { Parse } from "parse-hooks";
import type { NotificationArgsProps } from "antd";

type NotificationPlacement = NotificationArgsProps["placement"];

export const ImporterView = createComponent(function ImporterView() {
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = React.useState(false);

  // Hole die aktuelle Source - useSource gibt ein Array zurück [currentSource, setSource, allSources, isLoading, isEnabled]
  const [currentSource] = useSource();
  const sourceTag = currentSource?.tag || "";

  const openNotification = (placement: NotificationPlacement) => {
    api.info({
      message: `Erfolgreich angelegt!`,
      duration: 20,
      description:
        "Die Daten werden importiert. Dies kann einige Zeit in Anspruch nehmen. Die Seite wird anschließend neu geladen.",
      placement,
    });
  };

  return (
    <AdminLayout>
      {loading && <Loading message={"Daten werden importiert!"} />}

      {contextHolder}

      {!loading && (
        <ParseSetView
          className="ATN_QSData"
          customFilter={(query: Parse.Query) => {
            query.equalTo("source", sourceTag);
          }}
          view={
            {
              type: "table",
              fields: [
                "Document",
                "Zeitwert",
                "Anlage",
                "Schwellenwert",
                "tenant",
              ],
              // Filtere die Tabelle nach dem aktuellen source tag
            } as TableViewType
          }
          afterCreate={async (objectId) => {
            // Zeige Loading Animation sofort an
            setLoading(true);
            openNotification("top");

            try {
              const ATNQSData = Parse.Object.extend("ATN_QSData");
              const query = new Parse.Query(ATNQSData);
              const object = await query.get(objectId);

              // Setze den source Tag und speichere erneut
              object.set("source", sourceTag);
              await object.save();

              // Warte bis processingStatus auf "completed" steht
              const checkStatus = async () => {
                const statusQuery = new Parse.Query(ATNQSData);
                const currentObject = await statusQuery.get(objectId);
                const status = currentObject.get("processingStatus");

                console.log("Processing Status:", status);

                if (status === "completed") {
                  console.log("Verarbeitung abgeschlossen, lade Seite neu");
                  setLoading(false);
                  window.location.reload();
                } else if (status === "error") {
                  console.error("Fehler bei der Verarbeitung");
                  setLoading(false);
                  api.error({
                    message: "Fehler beim Importieren",
                    description:
                      "Es gab ein Problem beim Verarbeiten der CSV-Datei.",
                    placement: "top",
                  });
                } else {
                  // Status ist "processing" oder undefined, prüfe erneut in 2 Sekunden
                  setTimeout(checkStatus, 2000);
                }
              };

              // Starte Status-Polling
              checkStatus();
            } catch (error) {
              console.error("Fehler beim Speichern:", error);
              setLoading(false);
            }
          }}
        />
      )}
    </AdminLayout>
  );
});
